export default __webpack_public_path__ + "static/media/lit3.09c8aed0.svg";